import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, take } from 'rxjs/operators';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { isVisualizacaoModoList } from '../../../../common/visualizacao-modo';
import { ApiError, AuthService, BaseFilterCollapse, BaseFilterCollapseService, ConfigService, MessageService } from '../../../../core';
import { Cidade, CidadeSearchesHttpService, CidadeSubRegiao, CidadeSubRegiaoBairro } from '../../../cidade';
import { ConfigEmpresa } from '../../../configuracoes/app/empresa';
import { MetaFilterSearch } from '../../../meta/filter';
import { MetaMultiselectComponent } from '../../../meta/multiselect';
import { RegiaoCidadeSubRegiaoHttpService } from '../../../regiao';
import { ClienteAnaliseMercadoFilter } from '../../adapters';
import { isPerspectivaClassificacao, isPerspectivaMeta, isPerspectivaProjetada, isPerspectivaProjetadaOuMeta, isPerspectivaRAP } from '../../perspectivas/cliente-analise-mercado-perspectiva';
import { ClienteAnaliseMercadoFilterStorageService } from './cliente-analise-mercado-filter-storage.service';

@Component({
    selector: 'sgt-cliente-analise-mercado-filter',
    templateUrl: './cliente-analise-mercado-filter.component.html',
    styleUrls: ['./cliente-analise-mercado-filter.component.less']
})
export class ClienteAnaliseMercadoFilterComponent implements BaseFilterCollapse, OnInit, AfterViewInit, OnChanges, OnDestroy {
    filter = new ClienteAnaliseMercadoFilter();
    configEmpresa: ConfigEmpresa;
    isAdministrador: boolean;
    isRepresentante: boolean;

    /** Modo da visualização da análise de mercado */
    @Input() visualizacaoModo: number;
    /** Perspectiva da visualização da análise de mercado */
    @Input() visualizacaoPerspectiva: number;

    filterPsqSubscription: Subscription;
    isFilterInitializing = false;
    isFilterInitialized = false;
    /** Quando o filtro estiver inicializado */
    @Output() filterInitialized = new EventEmitter<any>();
    /** Ao alterar algum valor no filtro */
    @Output() filterChange = new EventEmitter<any>();
    /** Ao limpar o filtro */
    @Output() filterClear = new EventEmitter<void>();

    /** Se deve exibir o filtro dos representantes */
    @Input() isShowRepresentantesFilter = true;
    /** Ao alterar o filtro dos representantes */
    @Output() filterRepresentantesChange = new EventEmitter<void>();

    // Filter collapse
    @Input() isCollapsedInDefault = false;
    isCollapsedIn = false;
    @ViewChild('filterCollapse') filterCollapse: ElementRef;
    collapseIcon = 'fas fa-caret-down';

    /** Multiselect da meta */
    @ViewChild('metaMultiselect') metaMultiselect: MetaMultiselectComponent;

    // Multiselects
    isFirstChangeClassificacoesRAP = true;
    isFirstChangeClassificacoesClientesMultiselect = true;
    isFirstChangeGruposClassificacoes = true;
    isFirstChangeClassificacoes = true;
    isFirstChangeRepresentante = true;
    isFirstChangeAtendentes = true;
    isFirstChangeEstados = true;
    isFirstChangeTiposClientes = true;
    isFirstChangeGruposEconomicos = true;

    // Sub-regiões das cidades dos clientes
    cidadesSubRegioesClientes: CidadeSubRegiao[] = [];
    isFirstChangeCidadesSubRegioesClientes = true;
    multiselectCidadesSubRegioesClientesOptions: IMultiSelectOption[];
    multiselectCidadesSubRegioesClientesSettings: IMultiSelectSettings = {
        enableSearch: true,
        containerClasses: 'container-multiselect dropup',
        showCheckAll: true,
        showUncheckAll: true,
        dynamicTitleMaxItems: 0,
    }
    multiselectCidadesSubRegioesClientesTexts: IMultiSelectTexts = {
        checkAll: 'Selecionar todas',
        uncheckAll: 'Limpar',
        checked: 'sub-região selecionada',
        checkedPlural: 'sub-regiões selecionadas',
        searchPlaceholder: 'Pesquisar...',
        defaultTitle: 'Selecionar sub-regiões',
        allSelected: 'Todos selecionadas',
        searchEmptyResult: 'Nenhuma sub-região encontrada',
        searchNoRenderText: 'Digite para pesquisar'
    }

    // Bairros das sub-regiões das cidades dos clientes
    isFirstChangeCidadesSubRegioesBairrosClientes = true;
    multiselectCidadesSubRegioesBairrosClientesOptions: IMultiSelectOption[];
    multiselectCidadesSubRegioesBairrosClientesSettings: IMultiSelectSettings = {
        enableSearch: true,
        containerClasses: 'container-multiselect dropup',
        showCheckAll: true,
        showUncheckAll: true,
        dynamicTitleMaxItems: 0,
    }
    multiselectCidadesSubRegioesBairrosClientesTexts: IMultiSelectTexts = {
        checkAll: 'Selecionar todos',
        uncheckAll: 'Limpar',
        checked: 'bairro selecionado',
        checkedPlural: 'bairro selecionados',
        searchPlaceholder: 'Pesquisar...',
        defaultTitle: 'Selecionar bairros',
        allSelected: 'Todos selecionados',
        searchEmptyResult: 'Nenhum bairro encontrado',
        searchNoRenderText: 'Digite para pesquisar'
    }

    isFirstChangeFilterPsq = true;
    @ViewChild('filterPsq') filterPsq: NgModel;

    constructor(private authService: AuthService,
                private messageService: MessageService,
                private baseFilterCollapseService: BaseFilterCollapseService,
                private configService: ConfigService,
                private clienteAnaliseMercadoFilterStorageService: ClienteAnaliseMercadoFilterStorageService,
                private cidadeSearchesHttpService: CidadeSearchesHttpService,
                private regiaoCidadeSubRegiaoHttpService: RegiaoCidadeSubRegiaoHttpService) { }


    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.isAdministrador = this.authService.isAdministrador();
        this.isRepresentante = this.authService.isRepresentante();

        // Aplicando o filtro salvo no storage
        this.clienteAnaliseMercadoFilterStorageService.applyFilter(this.filter);
        // Iniciando filtro
        this.initFilter();
    }

    ngAfterViewInit() {
        if (!this.isCollapsedInDefault) {
            jQuery(this.filterCollapse.nativeElement).css('display', 'none');
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isCollapsedInDefault') {
                if (changes[propName].isFirstChange()) {
                    setTimeout(() => {
                        this.isCollapsedIn = changes[propName].currentValue;
                    }, 100);
                }
            } else if (propName === 'visualizacaoModo') {
                // Setando o modo da visualização no filter
                this.filter.visualizacaoModo = this.visualizacaoModo;

                if (!changes[propName].isFirstChange()) {
                    // Pesquisando as metas
                    if ((this.isVisualizacaoModoList() && this.isPerspectivaMeta()) || !this.metaMultiselect?.hasOptions()) {
                        setTimeout(() => {
                            this.searchMetas()
                            .then(() => {})
                            .catch(() => {});
                        }, 0);
                    }
                }
            } else if (propName === 'visualizacaoPerspectiva') {
                // Setando a perspectiva da visualização no filter
                this.filter.visualizacaoPerspectiva = this.visualizacaoPerspectiva;

                // Pesquisando as metas
                if (this.isShowMeta()) {
                    setTimeout(() => {
                        this.searchMetas()
                        .then(() => {})
                        .catch(() => {});
                    }, 0);
                }
            }
        }
    }

    /** Inicializa o filtro */
    private async initFilter() {
        this.isFilterInitializing = true;
        this.isFilterInitialized = false;

        setTimeout(() => {
            // Pesquisando as sub-regiões se possuir uma cidade filtrada
            if (this.filter.cidadeCliente?.possuiSubRegioes) {
                this.searchCidadesSubRegioesClientes(false);
            }

            // Criando filtro de pesquisa
            this.subscribeToFilterPsq();

            this.isFilterInitializing = false;
            this.isFilterInitialized = true;

            // Emitindo o evento de que o filtro foi inicializado
            this.filterInitialized.emit();
        }, 200);
    }

    // Realiza o subscribe nas alterações feitas no input do filtro da pesquisa
    private subscribeToFilterPsq() {
        this.filterPsqSubscription = this.filterPsq?.valueChanges
            .pipe(
                debounceTime(1000), // Dando um debounce de 1000ms para emitir a alteração
                map(emittedValue => emittedValue?.trim()),
                distinctUntilChanged()
            )
            .subscribe(() => {
                if (this.isFirstChangeFilterPsq) {
                    this.isFirstChangeFilterPsq = false;
                    return;
                }

                this.filterChange.emit();
            });
    }

    /** Verifica se deve exibir o filtro de pesquisa rápida */
    isShowFilterPsq(): boolean {
        return this.isVisualizacaoModoList();
    }

    /** Armazena os dados do filtro no storage */
    setStorage() {
        this.clienteAnaliseMercadoFilterStorageService.set(this.filter);
    }

    /** Emite evento de alteração no filtro para atualizar a pesquisa */
    refresh() {
        this.close();
        this.filterChange.emit();
    }

    /** Limpa o filtro e atualiza a pesquisa */
    clear() {
        this.baseFilterCollapseService.clear(this);
        this.filterClear.emit();
    }

    /** Retorna os ID's dos representantes sendo filtrados */
    getIdsRepresentante(): number[] {
        return this.filter.idsRepresentantes ?? [];
    }

    /** Abre/Fecha o filtro */
    toggleCollapse() {
        this.baseFilterCollapseService.toggleCollapse(this);
    }

    /** Abre o filtro */
    open() {
        this.baseFilterCollapseService.open(this);
    }

    /** Fecha o filtro */
    close() {
        this.baseFilterCollapseService.close(this);
    }

    /** Verifica se o modo da visualização é o list */
    isVisualizacaoModoList(): boolean {
        return isVisualizacaoModoList(this.visualizacaoModo);
    }

    /** Verifica se é a prespectiva RAP  */
    isPerspectivaRAP(): boolean {
        return isPerspectivaRAP(this.visualizacaoPerspectiva);
    }

    /** Verifica se é a prespectiva Classificação  */
    isPerspectivaClassificacao(): boolean {
        return isPerspectivaClassificacao(this.visualizacaoPerspectiva);
    }

    /** Verifica se é a prespectiva projetada  */
    isPerspectivaProjetada(): boolean {
        return isPerspectivaProjetada(this.visualizacaoPerspectiva);
    }

    /** Verifica se é a prespectiva meta  */
    isPerspectivaMeta(): boolean {
        return isPerspectivaMeta(this.visualizacaoPerspectiva);
    }

    /** Verifica se é a prespectiva projetada ou meta  */
    isPerspectivaProjetadaOuMeta(): boolean {
        return isPerspectivaProjetadaOuMeta(this.visualizacaoPerspectiva);
    }

    /** Ao alterar a periodicidade do datepicker */
    onChangePeriodicidade(periodicidade: number) {
        this.filter.periodicidadeSelecionada = periodicidade;
    }

    /** Ao alterar as Classificações RAP */
    onChangeClassificacoesRAP() {
        if (this.isFirstChangeClassificacoesRAP) {
            this.isFirstChangeClassificacoesRAP = false;
            return;
        }
        this.filterChange.emit();
    }

    /** Ao alterar os indicadores de Customer Share RAP */
    onChangeIndicadoresCustomerShareRAP() {
        this.filterChange.emit();
    }

    /** Ao alterar os indicadores de Customer Share RAR */
    onChangeIndicadoresCustomerShareRAR() {
        this.filterChange.emit();
    }

    /** Ao alterar os status pretendidos */
    onChangeStatusPretendidos() {
        this.filterChange.emit();
    }

    /** Ao alterar os status projetados */
    onChangeStatusProjetados() {
        this.filterChange.emit();
    }

    /** Pesquisa as metas no multiselect das metas */
    searchMetas(): Promise<void> {
        return new Promise<void>((resolve) => {
            const filterMetas = new MetaFilterSearch();
            filterMetas.mes = this.filter.mes;
            filterMetas.ano = this.filter.ano;
            filterMetas.idsRepresentantes = this.filter.idsRepresentantes;
            this.metaMultiselect?.search(filterMetas)
                .then(() => {
                    // Se não possuir a meta do filtro no multiselect então removemos a meta do filtro
                    if (!this.metaMultiselect.possuiMeta(this.filter.idMeta)) {
                        this.filter.idsMetas = [];
                        this.filter.idMeta = null;
                    }
                    resolve();
                })
                .catch(() => resolve());
        });
    }

    /** Verifica se deve exibir o filtro da meta */
    isShowMeta(): boolean {
        return (this.isVisualizacaoModoList() && this.isPerspectivaMeta());
    }

    /** Ao alterar a meta */
    onChangeMeta() {
        this.filter.idMeta = this.filter.idsMetas?.length === 1 ? this.filter.idsMetas[0] : null;
        this.filterChange.emit();
    }

    /** Ao alterar as classificações de clientes */
    onChangeClassificacoesClientes() {
        if (this.isFirstChangeClassificacoesClientesMultiselect) {
            this.isFirstChangeClassificacoesClientesMultiselect = false;
            return;
        }
        this.filterChange.emit();
    }

    /** Ao alterar os grupos de classificações */
    onChangeGruposClassificacoes() {
        if (this.isFirstChangeGruposClassificacoes) {
            this.isFirstChangeGruposClassificacoes = false;
            return;
        }
        this.filterChange.emit();
    }

    /** Ao destruir o multiselect dos grupos de classificações */
    onDestroyGruposClassificacoes() {
        this.isFirstChangeGruposClassificacoes = true;
    }

    /** Verifica se deve exibir o filtro das classificações */
    isShowClassificacoes(): boolean {
        return (this.isVisualizacaoModoList() && !this.isPerspectivaMeta());
    }

    /** Ao alterar as classificações */
    onChangeClassificacoes() {
        if (this.isFirstChangeClassificacoes) {
            this.isFirstChangeClassificacoes = false;
            return;
        }
        this.filterChange.emit();
    }

    /** Ao destruir o multiselect das classificações */
    onDestroyClassificacoes() {
        this.isFirstChangeClassificacoes = true;
    }

    /** Ao alterar os representantes */
    onChangeRepresentantes() {
        if (this.isFirstChangeRepresentante) {
            this.isFirstChangeRepresentante = false;
            return;
        }

        // Atualizando as sub-regiões e bairros das cidades disponíveis para os representantes selecionados
        this.searchCidadesSubRegioesClientes();

        // Se a perpectiva for por meta primeiros pesquisamos as metas do mês e ano e depois emitimos o evento de alteração da data
        if (this.isShowMeta()) {
            this.searchMetas()
                .then(() => this.filterRepresentantesChange.emit())
                .catch(() => this.filterRepresentantesChange.emit());
        } else {
            this.filterRepresentantesChange.emit();
        }
    }

    /** Ao alterar os atendentes */
    onChangeAtendentes() {
        if (this.isFirstChangeAtendentes) {
            this.isFirstChangeAtendentes = false;
            return;
        }

        this.filter.isFilterDirty = true;
        this.filterChange.emit();
    }

    /** Ao alterar os cadastros dos clientes */
    onChangeCadastrosClientes() {
        this.filterChange.emit();
    }

    /** Ao alterar as situações dos clientes */
    onChangeSituacoesClientes() {
        this.filterChange.emit();
    }

    /** Ao alterar os tipos de clientes */
    onChangeClientesTipos() {
        this.filter.isFilterDirty = true;
    }

    /** Ao alterar os grupos dos clientes */
    onChangeClientesGrupos() {
        this.filter.isFilterDirty = true;
    }


    /** Ao alterar os grupos econômicos dos clientes */
    onChangeClientesGruposEconomicos() {
        if (this.isFirstChangeGruposEconomicos) {
            this.isFirstChangeGruposEconomicos = false;
            return;
        }
        this.filter.isFilterDirty = true;
    }

    /** Ao alterar os tipos de itens dos clientes */
    onChangeItensTiposClientes() {
        if (this.isFirstChangeTiposClientes) {
            this.isFirstChangeTiposClientes = false;
            return;
        }
        this.filter.isFilterDirty = true;
    }


    /** Ao alterar os estados dos clientes */
    onChangeEstadosClientes() {
        if (this.isFirstChangeEstados) {
            this.isFirstChangeEstados = false;
            return;
        }
        this.filter.isFilterDirty = true;
    }

    /** Ao selecionar a cidade do cliente */
    onSelectCidadeCliente(cidade: Cidade) {
        if (cidade) {
            this.filter.idCidadeCliente = cidade.id;
            this.filter.isFilterDirty = true;
            // Atualizando as sub-regiões e bairros da cidade selecionada
            this.searchCidadesSubRegioesClientes();
        } else {
            this.clearCidadesSubRegioesClientes();
        }
    }

    /** Ao remover a cidade do cliente */
    onClearCidadeCliente() {
        this.filter.idCidadeCliente = null;
        this.clearCidadesSubRegioesClientes();
    }

    /** Pesquisa as sub-regiões da cidade do cliente */
    private searchCidadesSubRegioesClientes(clear = true) {
        if (clear) {
            this.clearCidadesSubRegioesClientes();
        }

        this.searchCidadeSubRegioesClientesDisponiveis()
            .then(subRegioes => {
                this.cidadesSubRegioesClientes = subRegioes;

                // Adicionando as sub-regiões no multiselect
                if (subRegioes) {
                    const selects: IMultiSelectOption[] = [];
                    subRegioes.forEach(entity => {
                        selects.push({
                            id: entity.id,
                            name: entity.nome
                        });
                    });
                    this.multiselectCidadesSubRegioesClientesOptions = selects;
                }

                // Pesquisando os bairros das sub-regiões
                this.searchCidadesSubRegioesBairrosClientes(clear);
            })
            .catch((error: ApiError) => {
                this.messageService.error(error.message, 'Erro ao pesquisar as sub-regiões e bairros da cidade', error);
                this.clearCidadesSubRegioesClientes();
            });
    }

    /** Pesquisa as sub-regiões dispoiníveis na cidade do cliente */
    private searchCidadeSubRegioesClientesDisponiveis(): Promise<CidadeSubRegiao[]> {
        return new Promise<CidadeSubRegiao[]>((resolve, reject) => {
            if (!this.filter.idCidadeCliente) {
                resolve([]);
                return;
            }

            const idsRepresentantes = this.isRepresentante ? [this.authService.getIdRepresentante()] : this.filter.idsRepresentantes;
            if (idsRepresentantes?.length > 0) { // Pesquisando somente as sub-regiões e bairros disponíveis para os representantes
                this.regiaoCidadeSubRegiaoHttpService.searchDisponiveisParaRepresentantes(idsRepresentantes, this.filter.idCidadeCliente)
                    .pipe(
                        take(1)
                    )
                    .subscribe(
                        subRegioes => resolve(subRegioes),
                        (error: ApiError) => reject(error)
                    );
            } else { // Pesquisando todas as sub-regiões e bairros da cidade
                this.cidadeSearchesHttpService.searchSubRegioes(this.filter.idCidadeCliente, true)
                    .pipe(
                        take(1)
                    )
                    .subscribe(
                        subRegioes => resolve(subRegioes),
                        (error: ApiError) => reject(error)
                    );
            }
        });
    }

    /** Ao alterar as sub-regiões das cidades dos clientes */
    onChangeCidadesSubRegioesClientes() {
        if (this.isFirstChangeCidadesSubRegioesClientes) {
            this.isFirstChangeCidadesSubRegioesClientes = false;
            return;
        }
        this.filter.isFilterDirty = true;
        this.searchCidadesSubRegioesBairrosClientes()
    }

    /** Limpa as sub-regiões e seus bairros dos clientes */
    private clearCidadesSubRegioesClientes() {
        // Cidade Sub-Regiões
        this.cidadesSubRegioesClientes = [];
        this.filter.idsCidadesSubRegioesClientes = [];
        this.multiselectCidadesSubRegioesClientesOptions = [];
        // Cidade Sub-Regiões Bairros
        this.clearCidadesSubRegioesBairrosClientes();
    }

    /** Pesquisa os bairros das sub-regiões */
    private searchCidadesSubRegioesBairrosClientes(clear = true) {
        if (clear) {
            this.clearCidadesSubRegioesBairrosClientes();
        }

        // Obtendo as sub-regiões selecionadas
        let subRegioes: CidadeSubRegiao[] = [];
        if (this.filter.idsCidadesSubRegioesClientes?.length > 0) { // Filtrando somente as sub-regiões selecionadas no filtro
            subRegioes = this.cidadesSubRegioesClientes?.filter(subRegiaoFilter => this.filter.idsCidadesSubRegioesClientes?.includes(subRegiaoFilter.id));
        } else { // Todas as sub-regiões
            subRegioes = this.cidadesSubRegioesClientes;
        }

        // Obtendo os bairros das sub-regiões selecionadas
        const bairros = new Map<number, CidadeSubRegiaoBairro>();
        subRegioes?.forEach(subRegiao => subRegiao.bairros?.forEach(bairro => bairros.set(bairro.id, bairro)));
        // Adicionando os bairros no multiselect
        if (bairros.size > 0) {
            const selects: IMultiSelectOption[] = [];
            bairros.forEach(bairro => {
                selects.push({
                    id: bairro.id,
                    name: bairro.nome
                });
            });
            this.multiselectCidadesSubRegioesBairrosClientesOptions = selects;
        }
    }

    /** Limpa os bairros das sub-regiões dos clientes */
    private clearCidadesSubRegioesBairrosClientes() {
        this.filter.idsCidadesSubRegioesBairrosClientes = [];
        this.multiselectCidadesSubRegioesBairrosClientesOptions = [];
    }

    /** Ao alterar os bairros das sub-regiões dos clientes */
    onChangeCidadesSubRegioesBairrosClientes() {
        if (this.isFirstChangeCidadesSubRegioesBairrosClientes) {
            this.isFirstChangeCidadesSubRegioesBairrosClientes = false;
            return;
        }
        this.filter.isFilterDirty = true;
    }

    ngOnDestroy() {
        this.filterPsqSubscription?.unsubscribe();
    }
}
